import { DetailedComplexEnumItem } from '../../../utils/complexEnum/DetailedComplexEnumItem'

type Type =
  | 'string'
  | 'Date'
  | 'number'
  | 'boolean'
  | 'ListCustomFieldValue'
  | 'BooleanListCustomFieldValue'
  | 'ReportCustomFieldValue'
  | 'EntityCustomFieldValue'

export class CustomFieldDataTypeItem<
  ID extends Lowercase<string>,
  Name extends string,
  DataType extends Type | Type[]
> extends DetailedComplexEnumItem<ID, Name> {
  /**
   * the associated data type of the custom field
   */
  dataType!: DataType
  constructor({
    dataType,
    ...basic
  }: Pick<
    CustomFieldDataTypeItem<ID, Name, DataType>,
    'description' | 'id' | 'name' | 'dataType'
  >) {
    super(basic)
    this.dataType = dataType
  }
}
